export default "__VITE_ASSET__BCvZ0ldb__"